import { combineReducers } from 'redux'
import * as busyIndicator from './widgets/busyIndicator'
import * as modal from './widgets/modal'
import * as pendingRequest from './infrastructure/pendingRequest'
import * as notificationPopup from './infrastructure/notificationPopup'
import * as users from './features/users'
import * as httpCache from './infrastructure/httpCache'
import * as settings from './features/settings'
import * as userContext from './features/userContext'
import * as Reports from './features/Reports'
import * as Account from './features/Account'
import * as Customers from './features/Customers'
import * as Profile from './features/Profile'
import * as Wizard from './widgets/Wizard'
import * as ReleaseNotes from './features/ReleaseNotes'

export default combineReducers({
	[busyIndicator.name]: busyIndicator.reducer,
	[modal.name]: modal.reducer,
	[pendingRequest.name]: pendingRequest.reducer,
	[notificationPopup.name]: notificationPopup.reducer,
	[httpCache.name]: httpCache.reducer,
	[users.name]: users.reducer,
	[settings.name]: settings.reducer,
	[userContext.name]: userContext.reducer,
	[Reports.name]: Reports.reducer,
	[Account.name]: Account.reducer,
	[ReleaseNotes.name]: ReleaseNotes.reducer,
	[Customers.name]: Customers.reducer,
	[Profile.name]: Profile.reducer,
	[Wizard.name]: Wizard.reducer,
})
